module.exports = __webpack_public_path__ + "img/mon_24.7849051b.png";